import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Menu, Phone, X } from "lucide-react";
import { LogoImage } from "./Logo";

const NAV = [
  { label: "Services", href: "#services", testid: "nav-link-services" },
  { label: "Areas", href: "#areas", testid: "nav-link-areas" },
  { label: "Contact", href: "#contact", testid: "nav-link-contact" },
];

export const Header = ({ onNav }) => {
  const [open, setOpen] = useState(false);

  const go = (e, href) => {
    e.preventDefault();
    setOpen(false);
    onNav(href);
  };

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 border-b-4 border-orange bg-navy text-white"
      style={{ paddingTop: "env(safe-area-inset-top)" }}
    >
      <div className="safe-x mx-auto flex h-16 max-w-7xl items-center justify-between md:h-20">
        <a
          href="#top"
          data-testid="header-logo"
          className="flex items-center gap-3"
          onClick={(e) => go(e, "#top")}
        >
          <LogoImage className="h-11 w-auto md:h-14" />
        </a>

        <nav aria-label="Primary" className="hidden items-center gap-9 md:flex">
          {NAV.map((item) => (
            <a
              key={item.href}
              href={item.href}
              data-testid={item.testid}
              className="nav-link"
              onClick={(e) => go(e, item.href)}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a href="tel:0424424600" data-testid="header-call-button" className="btn-primary hidden sm:inline-flex">
            <Phone className="h-4 w-4" aria-hidden="true" />
            Call now
          </a>
          <button
            type="button"
            data-testid="mobile-menu-button"
            aria-expanded={open}
            aria-label={open ? "Close menu" : "Open menu"}
            className="flex h-11 w-11 items-center justify-center border-2 border-white/25 text-white transition-colors duration-200 hover:border-orange md:hidden"
            onClick={() => setOpen((v) => !v)}
          >
            {open ? <X className="h-5 w-5" aria-hidden="true" /> : <Menu className="h-5 w-5" aria-hidden="true" />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            aria-label="Mobile"
            data-testid="mobile-menu"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.25, ease: "easeOut" }}
            className="safe-x overflow-hidden border-t border-white/10 md:hidden"
          >
            <div className="flex flex-col py-4">
              {NAV.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  data-testid={`mobile-${item.testid}`}
                  className="border-b border-white/10 py-4 font-display text-lg uppercase tracking-[0.2em] text-white/90 transition-colors duration-200 hover:text-orange"
                  onClick={(e) => go(e, item.href)}
                >
                  {item.label}
                </a>
              ))}
              <a
                href="tel:0424424600"
                data-testid="mobile-call-button"
                className="btn-primary mt-4 justify-center"
              >
                <Phone className="h-4 w-4" aria-hidden="true" />
                Call 0424 424 600
              </a>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
